<ng-container *ngIf="!(bffSearchFeatureFlag$ | async); else displayBffSearch">
  <flo-old-search></flo-old-search>
</ng-container>
<ng-template #displayBffSearch>
  <!-- skeletons -->
  <ng-container *ifLoaded="(searchLayout$ | async) || (message$ | async); template: 'right-rail-list'"></ng-container>
  <div *ngIf="!(isLayoutError$ | async); else errorMessage" class="min-vh-100">
    <ng-container *ngIf="searchLayout$ | async as searchLayout;">
      <flo-content-right-rail-layout
        class="search-page"
        [container]="(searchPartial$ | async)?.data || searchLayout.content"
        [topContent]="searchLayout.topContent"
        [secondaryContainer]="searchLayout.rightRailContent"
        [bottomContent]="searchLayout.bottomContent"
        [isPartialError]="isPartialError$ | async"
        [isLoading]="isLoading$ | async"
        [message]="message$ | async"
      ></flo-content-right-rail-layout>
    </ng-container>
  </div>
</ng-template>
<ng-template #errorMessage>
  <div class="container bg-white min-vh-100 py-5">
    <flo-error></flo-error>
  </div>
</ng-template>
